import { Command } from "commander";
import chalk from "chalk";
import { buildDependencyGraph } from "../graph/dependencyGraphBuilder.js";
import { exportGraphAsText, exportGraphAsJson } from "../graph/graphExporter.js";

export const graphCommand = new Command("graph")
  .description("Build and display the project dependency graph")
  .option("--json", "Output in JSON format")
  .action(async (options: { json?: boolean }) => {
    const cwd = process.cwd();
    try {
      const graph = await buildDependencyGraph(cwd);

      if (options.json) {
        console.log(exportGraphAsJson(graph));
        process.exit(0);
        return;
      }

      console.log();
      const text = exportGraphAsText(graph);
      // Colorize the text output
      const lines = text.split("\n");
      for (const line of lines) {
        if (line.startsWith("Dependency Graph")) {
          console.log(chalk.bold.underline(line));
        } else if (line.startsWith("React Native:") || line.startsWith("Legend:")) {
          console.log(chalk.dim(line));
        } else if (line.startsWith("─")) {
          console.log(chalk.dim(line));
        } else if (line.endsWith("Modules") || line.endsWith("Dependencies") || line.endsWith("Support")) {
          console.log(chalk.bold(line));
        } else if (line.includes("[N]")) {
          console.log(chalk.cyan(line));
        } else if (line.includes("[P]")) {
          console.log(chalk.green(line));
        } else if (line.includes("[D]")) {
          console.log(chalk.dim(line));
        } else {
          console.log(line);
        }
      }
      console.log();
    } catch (err: any) {
      if (options.json) {
        console.log(JSON.stringify({ success: false, error: err?.message }, null, 2));
      } else {
        console.log(chalk.red(`✖ ${err?.message || "Unknown error"}`));
      }
      process.exit(1);
    }
  });
